// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"LocationDetails_fieldsWrapper__h0T64"};